import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import * as XLSX from 'xlsx';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from "../COMPONENTS/Loader";
import { openCommentModal } from "./../../REDUX/functions";

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class AddProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            SENDING: false,
            PRODUCTS: [this.getClearProduct()],
        }
    }

    componentDidMount = () => {
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    isVaild = () => {
        if (!this.state.PRODUCTS.length) {
            return false
        }

        let errors = []
        this.state.PRODUCTS.map((product, index) => {
            for (let key in product) {
                if ((product[key].type == 'text' || product[key].type == 'textarea') && !product[key].value.length) {
                    errors.push({ index, key })
                }
                if (product[key].type == 'number' && !product[key].value.toString().length) {
                    errors.push({ index, key })
                }
                if (key == 'size') {
                    if (!this.checkSizes(product[key].value)) {
                        errors.push({ index, key })
                    }
                }
                if (key == 'supplier_price' && product[key].value <= 0) {
                    errors.push({ index, key })
                }
            }
        })

        if (!errors.length) {
            return true
        }

        return false
    }

    getClearProduct = () => {
        return {
            vendor_code: { type: 'text', value: '' },
            barcode: { type: 'number', value: '' },
            additional_barcode: { type: 'checkbox', value: false },
            name: { type: 'text', value: '' },
            taxes: { type: 'number', value: 20 },
            ///commission_percent: { type: 'number', value: 35, is_commissioner: true },
            price: { type: 'number', value: 0, is_commissioner: true },
            supplier_price: { type: 'number', value: 0 },
            unit: {
                type: 'select', value: 'шт', options: [
                    'шт', 'кг', 'гр', 'уп', 'прц', 'пара', 'м'
                ]
            },
            weight_netto: { type: 'number', value: 0 },
            weight_brutto: { type: 'number', value: 0 },
            length: { type: 'number', value: 0 },
            width: { type: 'number', value: 0 },
            height: { type: 'number', value: 0 },
            description: { type: 'textarea', value: '' },
            sostav: { type: 'textarea', value: '' },
            calories: { type: 'number', value: 0 },
            carbohydrates: { type: 'number', value: 0 },
            fats: { type: 'number', value: 0 },
            proteins: { type: 'number', value: 0 },
            days_valid: { type: 'number', value: 0 },
            min_temperature: { type: 'number', value: 0 },
            max_temperature: { type: 'number', value: 0 },
            country: { type: 'text', value: '' },
            package_quant: { type: 'number', value: 1 },
            stm: { type: 'checkbox', value: false },
            freeze: { type: 'checkbox', value: false },
            organic: { type: 'checkbox', value: false },
            sugar_free: { type: 'checkbox', value: false },
            halal: { type: 'checkbox', value: false },
            vegan: { type: 'checkbox', value: false },
            farm: { type: 'checkbox', value: false },
            brand: { type: 'text', value: '' },
            image: { type: 'image', value: false },
        }
    }

    removeProduct = (removeAbleindex) => {
        this.setState({
            PRODUCTS: this.state.PRODUCTS.filter((product, index) => {
                return index !== removeAbleindex
            })
        })
    }

    addProduct = (reset = false) => {
        let products = [];

        if (!reset) {
            products = this.state.PRODUCTS
        }

        products.push(this.getClearProduct())

        this.setState({ PRODUCTS: products })
    }

    saveProducts = async () => {
        if (!this.isVaild()) {
            return
        }

        if (this.state.SENDING) {
            return
        }
        this.setState({ SENDING: true })

        let SEND_DATA = {};

        SEND_DATA = {
            products: this.state.PRODUCTS
        };

        try {
            let data = await Request(SEND_DATA, 'products/create');
            if (data !== false) {
                this.setState({ PRODUCTS: [this.getClearProduct()], SENDING: false });
                alert('Товары отправлены на модерацию');
            } else {
                this.setState({ SENDING: false });
            }
        } catch (error) {
        }
    }

    changeValue = (p_index, key, value) => {
        let newProducts = [...this.state.PRODUCTS]
        newProducts[p_index][key].value = value
        this.setState({ PRODUCTS: newProducts });
    }

    renderKeyLabel = (key) => {
        switch (key) {
            case 'barcode':
                return 'Штрихкод'
                break;
            case 'additional_barcode':
                return 'Маркировка честным знаком требуется'
                break;
            case 'vendor_code':
                return 'Артикул поставщика'
                break;
            case 'name':
                return 'Наименование'
                break;
            case 'taxes':
                return 'Ставка НДС'
                break;
            case 'commission_percent':
                return 'Процент комиссии'
                break;
            case 'price':
                return 'Цена продажи'
                break;
            case 'supplier_price':
                return 'Закупочная цена'
                break;
            case 'unit':
                return 'Ед. изм.'
                break;
            case 'weight_netto':
                return 'Вес нетто'
                break;
            case 'weight_brutto':
                return 'Вес брутто'
                break;
            case 'length':
                return 'Длина'
                break;
            case 'width':
                return 'Ширина'
                break;
            case 'height':
                return 'Высота'
                break;
            case 'description':
                return 'Описание'
                break;
            case 'sostav':
                return 'Состав ("Общие")'
                break;
            case 'calories':
                return 'Калорийность ("Общие", не на 100 грамм)'
                break;
            case 'carbohydrates':
                return 'Углеводы (гр.) ("Общие")'
                break;
            case 'fats':
                return 'Жиры (гр.) ("Общие")'
                break;
            case 'proteins':
                return 'Белки (гр.) ("Общие")'
                break;
            case 'days_valid':
                return 'Срок годности (дн.) ("Общие")'
                break;
            case 'min_temperature': return 'Хранение мин температура'
                break;
            case 'max_temperature':
                return 'Хранение макс температура'
                break;
            case 'country':
                return 'Страна производителя'
                break;
            case 'package_quant':
                return 'Количество в коробе (ед. измерения - коэффициент)'
                break;
            case 'image':
                return 'Загрузить фото'
                break;
            case 'stm':
                return 'СТМ Экомаркет'
                break;
            case 'freeze':
                return 'Заморозка'
                break;
            case 'organic':
                return 'Органика'
                break;
            case 'sugar_free':
                return 'Без сахара'
                break;
            case 'halal':
                return 'Халяль'
                break;
            case 'vegan':
                return 'Веган'
                break;
            case 'farm':
                return 'Фермерская'
                break;
            case 'brand':
                return 'Бренд на товаре'
                break;
        }
        return key
    }

    renderKeySuggest = (key) => {
        switch (key) {
            case 'barcode':
                return 'ШК должен быть указан в полном формате, без пробелов'
                break;
            case 'additional_barcode':
                return 'Ставим галочку , если нужно сканировать 2 штрихкод'
                break;
            case 'vendor_code':
                return ''
                break;
            case 'name':
                return 'Наименование как в товарной накладной ( не более 35 символов)'
                break;
            case 'taxes':
                return 'Выберите подходящий процент'
                break;
            case 'commission_percent':
                return 'Процент комиссии'
                break;
            case 'price':
                return 'Указать продажную цену на сайте с ндс , без копеек'
                break;
            case 'supplier_price':
                return 'Согласованная цена, как будет в накладной с НДС'
                break;
            case 'unit':
                return 'Единица измерения'
                break;
            case 'weight_netto':
                return 'чистый вес без упаковки указывается числом в граммах'
                break;
            case 'weight_brutto':
                return 'вес с упаковкой указывается числом в граммах'
                break;
            case 'length':
                return 'Длина в мм'
                break;
            case 'width':
                return 'Ширна в мм'
                break;
            case 'height':
                return 'Высота в мм'
                break;
            case 'description':
                return 'не более 350 символов , желательно писать что-то простое и понятное'
                break;
            case 'sostav':
                return 'Если есть Ешки , пописать их'
                break;
            case 'calories':
                return 'только число'
                break;
            case 'carbohydrates':
                return 'только число'
                break;
            case 'fats':
                return 'только число'
                break;
            case 'proteins':
                return 'только число'
                break;
            case 'days_valid':
                return 'только число'
                break;
            case 'min_temperature':
                return 'указываем минмальную температуру хранения '
                break;
            case 'max_temperature':
                return 'указываем максимальную температуру хранения '
                break;
            case 'country':
                return 'где сделали конечный продукт'
                break;
            case 'package_quant':
                return 'только число (сколько штук в коробе, квант упаковки)'
                break;
            case 'image':
                return <>выбрать файл и загрузить<br />не менее 800px и квадратного размера на белом фоне</>
                break;
            case 'stm':
                return 'Ставим галочку если соответсвует'
                break;
            case 'freeze':
                return 'Ставим галочку если соответсвует'
                break;
            case 'organic':
                return 'Ставим галочку если соответсвует'
                break;
            case 'sugar_free':
                return 'Ставим галочку если соответсвует'
                break;
            case 'halal':
                return 'Ставим галочку если соответсвует'
                break;
            case 'vegan':
                return 'Ставим галочку если соответсвует'
                break;
            case 'farm':
                return 'Ставим галочку если соответсвует'
                break;
            case 'brand':
                return 'Пишем бренд товара ( Nestle, Parmalat, Рябинки, СТМ Ecomarket и тд)'
                break;
        }
        return key
    }

    checkSizes = (value) => {
        let parts = value.split(',')
        let success = true

        if (parts.length < 3) {
            return false
        }

        for (var i = 0; i < parts.length; i++) {
            if (isNaN(parts[i]) || !parts[i].toString().length) {
                success = false;
                break;
            }
        }

        return success
    }

    getClassName = (type, value, key) => {
        if (key == 'supplier_price' && value <= 0) {
            return 'ap_input_error';
        }

        if (key == 'size') {
            if (!this.checkSizes(value)) {
                return 'ap_input_error';
            }
        }

        if ((type == 'text' || type == 'textarea') && !value.length) {
            return 'ap_input_error';
        }

        if (type == 'number' && !value.toString().length) {
            return 'ap_input_error';
        }

        if (type == 'text' && !value.length) {
            return 'ap_input_error'
        }

        return '';
    }

    renderValueInput = (index, key, inputValue) => {
        switch (inputValue.type) {
            case 'text':
                return <input type="text" value={ inputValue.value } onChange={ (e) => this.changeValue(index, key, e.target.value) } className={ this.getClassName('text', inputValue.value, key) } />
                break;
            case 'textarea':
                return <textarea value={ inputValue.value } onChange={ (e) => this.changeValue(index, key, e.target.value) } className={ this.getClassName('textarea', inputValue.value) } />
                break;
            case 'number':
                return <input type="number" min="0" value={ inputValue.value } onChange={ (e) => this.changeValue(index, key, e.target.value) } className={ this.getClassName('number', inputValue.value, key) } />
                break;
            case 'image':
                return (
                    <label>
                        { inputValue.value ? <img src={ inputValue.value } className="ap_image" /> : 'Выбрать изображение' }
                        <input type="file" min="0" onChange={ (e) => this.convertToBase64(index, key, e) } accept="image/png, image/gif, image/jpeg" style={ { display: 'none' } } />
                    </label>
                )
                break;
            case 'checkbox':
                return <label><input type="checkbox" min="0" checked={ inputValue.value } onChange={ (e) => this.changeValue(index, key, !inputValue.value) } /></label>
                break;
            case 'select':
                let options = []
                for (let i = 0; i < inputValue.options.length; i++) {
                    options.push(
                        <option key={ i } value={ inputValue.options[i] }>{ inputValue.options[i] }</option>
                    )
                }

                return (
                    <select value={ inputValue.value } onChange={ (e) => this.changeValue(index, key, e.target.value) } className={ this.getClassName('select', inputValue.value) } >
                        { options }
                    </select>
                )
                break;
        }
        return inputValue.value
    }

    handleFileUpload = (e) => {
        const reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        e.target.value = null;
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: 'binary' });
            const firstSheet = workbook.SheetNames[0];

            const firstSheetData = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);

            let productKeys = {
                1: false,
                2: false,
                3: false,
                4: false,
                5: false
            }

            let products = {
                1: this.getClearProduct(),
                2: this.getClearProduct(),
                3: this.getClearProduct(),
                4: this.getClearProduct(),
                5: this.getClearProduct(),
            }

            firstSheetData.map((item, index) => {
                if (index == 0) {
                    for (let key in productKeys) {
                        if (typeof item['Товар' + key] !== "undefined") {
                            productKeys[key] = true
                            products[key].vendor_code.value = item['Товар' + key]
                        }
                    }
                }

                if (index == 1) {
                    for (let key in productKeys) {
                        if (typeof item['Товар' + key] !== "undefined") {
                            productKeys[key] = true
                            products[key].barcode.value = item['Товар' + key]
                        }
                    }
                }

                if (index == 2) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].additional_barcode.value = true
                            }
                        }
                    }
                }

                if (index == 3) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].name.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 4) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].taxes.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 5) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].price.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 6) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].supplier_price.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 7) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].unit.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 8) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].weight_netto.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 9) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].weight_brutto.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 10) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].length.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 11) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].width.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 12) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].height.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 13) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].description.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 14) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].sostav.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 15) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].calories.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 16) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].carbohydrates.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 17) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].fats.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 18) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].proteins.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 19) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].days_valid.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 20) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].min_temperature.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 21) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].max_temperature.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 22) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].country.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 23) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].package_quant.value = item['Товар' + key]
                            }
                        }
                    }
                }

                if (index == 24) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].stm.value = true
                            }
                        }
                    }
                }

                if (index == 25) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].freeze.value = true
                            }
                        }
                    }
                }

                if (index == 26) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].organic.value = true
                            }
                        }
                    }
                }

                if (index == 27) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].sugar_free.value = true
                            }
                        }
                    }
                }

                if (index == 28) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].halal.value = true
                            }
                        }
                    }
                }

                if (index == 29) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].vegan.value = true
                            }
                        }
                    }
                }

                if (index == 30) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].farm.value = true
                            }
                        }
                    }
                }

                if (index == 31) {
                    for (let key in productKeys) {
                        if (productKeys[key]) {
                            if (typeof item['Товар' + key] !== "undefined") {
                                products[key].brand.value = item['Товар' + key]
                            }
                        }
                    }
                }
            })

            let finalProducts = []
            for (let key in productKeys) {

                if (productKeys[key]) {
                    finalProducts.push(products[key])
                }
            }

            this.addProductsFromXls(finalProducts)
            e.target.value = null;
        };
    }

    convertToBase64 = (index, key, event) => {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        var component = this

        reader.onload = (event) => {
            var image = new Image();


            //Set the Base64 string return from FileReader as source.
            image.src = event.target.result;

            //Validate the File Height and Width.
            image.onload = function () {
                var height = this.height;
                var width = this.width;

                if (height !== width) {
                    alert('Фотография должна быть квадратной!')
                    return
                }

                if (height < 800) {
                    alert('Фотография должна быть не менее 800px * 800px')
                    return
                }

                component.changeValue(index, key, reader.result)
            };
            ///
        };

        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
    }

    addProductsFromXls = (productsToAdd) => {
        if (!productsToAdd.length) {
            return
        }
        this.setState({ PRODUCTS: productsToAdd });
    }

    renderProducts = () => {
        if (this.state.PRODUCTS.length > 0) {
            let PRODUCTS = this.state.PRODUCTS;

            const keys = Object.keys(this.getClearProduct())

            return (
                <table>
                    <tbody>
                        { keys.map((key, index) => {
                            return (
                                <tr className="ap_row" key={ index }>
                                    <td className="ap_header">
                                        <div className="ap_header_title">{ this.renderKeyLabel(key) }</div>
                                        <div className="ap_header_suggest">{ this.renderKeySuggest(key) }</div>
                                    </td>

                                    { PRODUCTS.map((product, p_index) => {
                                        return (
                                            <td key={ index + '_' + p_index }>
                                                <div key={ p_index } className="ap_content">
                                                    { this.renderValueInput(p_index, key, product[key]) }
                                                </div>
                                            </td>
                                        )
                                    }) }


                                </tr>
                            )
                        }) }
                        <tr>
                            <td></td>
                            { PRODUCTS.map((product, p_index) => {
                                return (
                                    <td><a className="ap_remove" onClick={ () => this.removeProduct(p_index) }>Удалить</a></td>
                                )
                            }) }
                        </tr>
                    </tbody>
                </table>
            )
        } else {
            return null
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Добавление товаров</title>
                </Helmet>
                <div className="ap_header_row">
                    <div className="ap_loader">
                        <label>
                            <a className="filter_btn">
                                Загрузить xls
                            </a>
                            <input type="file" id="file" ref="file" onChange={ (e) => this.handleFileUpload(e) } style={ { display: 'none' } } />
                        </label>
                        <a className="ap_example" target="_blank" href="/public/example.xlsx">пример в XLSX</a>
                    </div>

                    <a className="active_btn" style={ { marginBottom: 10 } } onClick={ () => this.addProduct() }>
                        Добавить
                    </a>
                </div>

                { this.renderProducts() }

                <div className="addProductsFooter">
                    <a className={ this.isVaild() ? "filter_btn" : "filter_btn disabled" } onClick={ () => this.saveProducts() }>Добавить товары</a>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(AddProducts))
